
export enum Platform {
    None = 0,
    Verilocation = 1,
    Isotrak = 2,
    Seven = 3,
    Alcolock = 4,
    RTL = 5
}
